import React, { useState } from "react";
import Button from "../../components/controls/Button";
import Form from "../../components/Form/Form";
import useForm from "../../components/Form/useForm";
import Spinner from "../../components/Spinner/Spinner";
import { amplify } from "../../service/api/AuthService";
import { passwordValidator, repeatedPassword } from "../../utils/validators";
import "./ChangePassword.scss";
import { TextField } from "@mui/material";
import InputAdornment from '@material-ui/core/InputAdornment';
import VisibilityOutlined from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlined from '@material-ui/icons/VisibilityOffOutlined';
import IconButton from '@material-ui/core/IconButton';
import { useHistory } from "react-router-dom";
import ChangePassOk from "./ChangePassOk";
import ChangePassError from "./ChangePassError";



const fields = [
  { field: "password1", validation: (text) => passwordValidator(text, true) },
  {
    field: "password2",
    validation: (text) => passwordValidator(text, true),
  },
  {
    field: "repeatPassword",
    validation: repeatedPassword,
  },
];
const initialValues = Object.assign(
  ...fields.map((x) => ({ [x.field]: x.value || "" }))
);



const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    fields.forEach((value) => {
      if (value.field in fieldValues && value.validation)
        if (value.field === "repeatPassword") {
          temp[value.field] = value.validation(
            fieldValues[value.field],
            values["password2"]
          );
        } else temp[value.field] = value.validation(fieldValues[value.field]);
    });
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { handleInputChange, resetForm } = useForm(
    initialValues,
    validate,
    true,
    null,
    values,
    setValues,
    errors,
    setErrors
  );

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  let history = useHistory();
  const redirect = () => {
    history.push({
      pathname: `/score`,
    })
  }

  const handleSubmit = () => {
    if (validate()) {
      setLoading(true);
      const { password1, password2 } = values;
      amplify
        .currentAuthenticatedUser()
        .then((user) => {
          amplify
            .changePassword(user, password1, password2)
            .then(() => {
              setShowSuccess(true);
              resetForm();
            })
            .catch(() => {
              setShowError(true);
            });
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <div className="change-password-page d-flex align-items-center">

      <div className="change-password-container container">
      <Button className="close-icon-mobile" id="redirect-button" onClick={redirect}>
          <span ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M14.7.423a.905.905 0 0 0-1.205.066L7.631 6.353 1.766.49a.903.903 0 0 0-1.277 0L.423.562A.903.903 0 0 0 .49 1.766l5.864 5.865L.49 13.495a.903.903 0 0 0 0 1.278l.073.066a.902.902 0 0 0 1.204-.066l5.865-5.867 5.864 5.867a.903.903 0 0 0 1.278 0l.066-.074a.902.902 0 0 0-.066-1.204L8.907 7.631l5.866-5.864a.902.902 0 0 0 0-1.277l-.074-.065.001-.002z" fill="#5C157D" />
          </svg></span>
        </Button>
        {showSuccess && <ChangePassOk />}
        {showError && <ChangePassError />}

        <div className="col-lg-10 col-xl-7 bg-white col-12 form-container pt-1">
          <Button className="col close-icon me-1" id="redirect-button" onClick={redirect}>
            <span ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M14.7.423a.905.905 0 0 0-1.205.066L7.631 6.353 1.766.49a.903.903 0 0 0-1.277 0L.423.562A.903.903 0 0 0 .49 1.766l5.864 5.865L.49 13.495a.903.903 0 0 0 0 1.278l.073.066a.902.902 0 0 0 1.204-.066l5.865-5.867 5.864 5.867a.903.903 0 0 0 1.278 0l.066-.074a.902.902 0 0 0-.066-1.204L8.907 7.631l5.866-5.864a.902.902 0 0 0 0-1.277l-.074-.065.001-.002z" fill="#5C157D" />
            </svg></span>
          </Button>
          <Form
          className="form"
            onSubmit={handleSubmit}
          >
            <div className="text-start mt-3">
              <h2>Elige una contraseña</h2>
              <span>
                Recuerda que debe tener entre 7 y 15 caracteres, incluyendo una
                mayúscula, una minúscula y un número o símbolo.
              </span>
            </div>
            <TextField
              label="Contraseña actual"
              name="password1"
              type={showPassword ? 'text' : 'password'}
              autoComplete="on"
              placeholder="Introduce Contraseña actual"
              value={values.password1}
              onChange={handleInputChange}
              error={errors.password1}
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                    </IconButton>
                  </InputAdornment>
              }}
            />
            <TextField
              label="Nueva contraseña"
              name="password2"
              type={showPassword ? 'text' : 'password'}
              autoComplete="on"
              placeholder="Introduce Nueva Contraseña"
              value={values.password2}
              onChange={handleInputChange}
              error={errors.password2}
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                    </IconButton>
                  </InputAdornment>
              }}
            />
            <TextField
              label="Repite la nueva contraseña"
              name="repeatPassword"
              type={showPassword ? 'text' : 'password'}
              autoComplete="on"
              placeholder="Repeat new password"
              value={values.repeatPassword}
              onChange={handleInputChange}
              error={errors.repeatPassword}
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                    </IconButton>
                  </InputAdornment>
              }}
            />
            <div className="mt-5 d-flex d-inline justify-content-center">
              {loading ? (
                <Spinner />
              ) : (
                <>
                  <Button className="btn-send mb-2"
                    type="submit"
                    text="Establecer contraseña"
                    disabled={!values.repeatPassword || errors.password1 || errors.password2 || errors.repeatPassword}
                  />
                </>
              )}
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
